import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "min-h-screen"
}
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "font-bold text-center text-lg md:text-2xl" }
const _hoisted_4 = { class: "font-bold text-center text-sm md:text-xl" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_9 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "w-full px-2 md:w-8/12" }
const _hoisted_13 = { class: "block mb-1" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_16 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_17 = { class: "block mb-1" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_20 = { class: "block mb-1" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_23 = { class: "block mb-1" }
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_26 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_27 = { class: "block mb-1" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_30 = { class: "block mb-1" }
const _hoisted_31 = { class: "text-sm text-red-500 p-error" }
const _hoisted_32 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_33 = { class: "block mb-1" }
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_36 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_37 = { class: "block mb-1" }
const _hoisted_38 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_39 = { class: "block mb-1" }
const _hoisted_40 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_41 = { class: "block mb-1" }
const _hoisted_42 = { class: "text-sm text-red-500 p-error" }
const _hoisted_43 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_44 = { class: "block mb-1" }
const _hoisted_45 = { class: "text-sm text-red-500 p-error" }
const _hoisted_46 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_47 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_48 = { class: "block mb-1" }
const _hoisted_49 = { class: "text-sm text-red-500 p-error" }
const _hoisted_50 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_51 = { class: "block mb-1" }
const _hoisted_52 = { class: "text-sm text-red-500 p-error" }
const _hoisted_53 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_54 = { class: "block mb-1" }
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_57 = { class: "block mb-1" }
const _hoisted_58 = { class: "text-sm text-red-500 p-error" }
const _hoisted_59 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_60 = { class: "block mb-1" }
const _hoisted_61 = { class: "text-sm text-red-500 p-error" }
const _hoisted_62 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_63 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_64 = { class: "block mb-1" }
const _hoisted_65 = { class: "text-sm text-red-500 p-error" }
const _hoisted_66 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_67 = { class: "block mb-1" }
const _hoisted_68 = { class: "text-sm text-red-500 p-error" }
const _hoisted_69 = { class: "w-full px-2 md:w-5/12" }
const _hoisted_70 = { class: "block mb-1" }
const _hoisted_71 = { class: "text-sm text-red-500 p-error" }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_74 = { class: "w-full px-2" }
const _hoisted_75 = { class: "block mb-1" }
const _hoisted_76 = { class: "text-sm text-red-500 p-error" }
const _hoisted_77 = { class: "w-full mx-auto space-y-2 mt-2" }
const _hoisted_78 = { class: "group border rounded-lg p-3 bg-gray-50 shadow-md" }
const _hoisted_79 = { class: "flex justify-between items-center cursor-pointer font-semibold list-none" }
const _hoisted_80 = { class: "py-3 space-y-2 text-sm" }
const _hoisted_81 = { class: "text-gray-600" }
const _hoisted_82 = { class: "text-gray-600" }
const _hoisted_83 = { class: "text-gray-500" }
const _hoisted_84 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_85 = ["disabled"]
const _hoisted_86 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_87 = { class: "w-full px-2 flex flex-row gap-2" }
const _hoisted_88 = {
  for: "recibirNotificaciones",
  class: "cursor-pointer"
}
const _hoisted_89 = { class: "flex flex-wrap py-2 mt-8 space-x-2" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_92 = { class: "pi pi-check mr-2" }
const _hoisted_93 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FooterSection = _resolveComponent("FooterSection")!
  const _component_CambiarPasswordView = _resolveComponent("CambiarPasswordView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('titulo.acreditacion.invitados')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('label.complete.el.form')), 1),
            (_ctx.estadoAcreditadoExistente !== 'loading' && _ctx.estadoAcreditadoExistente === 'no-existe')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("div", { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }, [
                    _createElementVNode("div", { class: "w-full px-2 bg-blue-300 rounded-lg shadow-lg p-4 text-center font-bold text-white text-2xl" }, " NUEVO ")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.estadoAcreditadoExistente !== 'loading' && _ctx.estadoAcreditadoExistente === 'existe')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-full px-2 rounded-lg shadow-lg p-4 text-center font-bold text-white text-2xl", { 'bg-indigo-400': _ctx.acreditado.estadoAcreditado.id === 1, 'bg-green-400': _ctx.acreditado.estadoAcreditado.id === 2, 'bg-red-400': _ctx.acreditado.estadoAcreditado.id === 3 }])
                    }, _toDisplayString(_ctx.acreditado.estadoAcreditado.id === 1 ? _ctx.$t('estado.pendiente') :
                  _ctx.acreditado.estadoAcreditado.id === 2 ? _ctx.$t('estado.verificado') :
                    _ctx.acreditado.estadoAcreditado.id === 3 ? _ctx.$t('estado.rechazado') : ''), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.documento')), 1),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      readonly: "true",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.documento')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('label.tipo.acreditado')), 1),
                _createVNode(_component_Field, {
                  name: "tipoAcreditado",
                  modelValue: _ctx.formData.tipoAcreditado,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.tipoAcreditado) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: _ctx.$t('label.tipo.acreditado'),
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                      options: _ctx.tiposAcreditados,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "tipoAcreditado" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('label.nombre')), 1),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.nombre')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('label.apellido')), 1),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.apellido')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('label.genero')), 1),
                _createVNode(_component_Field, {
                  name: "genero",
                  modelValue: _ctx.formData.genero,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.genero) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: _ctx.$t('label.genero'),
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                      options: _ctx.translatedGeneros,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_ErrorMessage, { name: "genero" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('label.empresa')) + " (" + _toDisplayString(_ctx.$t('label.opcional')) + ")", 1),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.empresa')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('label.cargo')) + " (" + _toDisplayString(_ctx.$t('label.opcional')) + ")", 1),
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.cargo')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('label.cuit')) + " (" + _toDisplayString(_ctx.$t('label.opcional')) + ")", 1),
                _createVNode(_component_Field, {
                  name: "cuit",
                  modelValue: _ctx.formData.cuit,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.cuit) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.cuit')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_34, [
                      _createVNode(_component_ErrorMessage, { name: "cuit" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('label.pais')), 1),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  options: _ctx.translatedCountries,
                  optionLabel: "value",
                  placeholder: _ctx.$t('label.pais'),
                  class: "input-base"
                }, null, 8, ["modelValue", "options", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('label.codigo.pais')), 1),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.code,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                      class: "input-base",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[25] || (_cache[25] = _createTextVNode("º ", -1)),
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('label.codigo.area')), 1),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.codigo.area')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_42, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('label.celular')), 1),
                _createVNode(_component_Field, {
                  name: "numeroTelefono",
                  modelValue: _ctx.formData.numeroTelefono,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.numeroTelefono) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.celular')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_45, [
                      _createVNode(_component_ErrorMessage, { name: "numeroTelefono" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('label.pais.residencia')), 1),
                _createVNode(_component_Field, {
                  name: "paisDomicilio",
                  modelValue: _ctx.formData.paisDomicilio,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.paisDomicilio) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      filter: "",
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                      placeholder: "País",
                      options: _ctx.translatedResidenceCountries,
                      optionLabel: "value"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_49, [
                      _createVNode(_component_ErrorMessage, { name: "paisDomicilio" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.paisDomicilio?.code == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('label.provincia')), 1),
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: _ctx.$t('errors.seleccione.opcion'),
                          options: _ctx.provincias,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                        _createElementVNode("span", _hoisted_52, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('label.provincia')), 1),
                    _createVNode(_component_Field, {
                      name: "provinciaEstado",
                      modelValue: _ctx.formData.provinciaEstado,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su provincia o estado",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_55, [
                          _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('label.localidad')), 1),
                    _createVNode(_component_Field, {
                      name: "localidad",
                      modelValue: _ctx.formData.localidad,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.localidad) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          filter: "",
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: _ctx.$t('errors.seleccione.opcion'),
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                          options: _ctx.localidades,
                          optionLabel: "descripcion"
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                        _createElementVNode("span", _hoisted_58, [
                          _createVNode(_component_ErrorMessage, { name: "localidad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('label.localidad')), 1),
                    _createVNode(_component_Field, {
                      name: "localidadCiudad",
                      modelValue: _ctx.formData.localidadCiudad,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su localidad o ciudad",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_61, [
                          _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('label.mail')), 1),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.mail')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('label.fecha.nacimiento')), 1),
                _createVNode(_component_Field, {
                  name: "fechaNacimiento",
                  modelValue: _ctx.formData.fechaNacimiento,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.fechaNacimiento) = $event))
                }, {
                  default: _withCtx(({ value, handleChange, handleBlur, errors }) => [
                    _createVNode(_component_InputMask, {
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      onBlur: handleBlur,
                      mask: "99/99/9999",
                      slotChar: "dd/mm/yyyy",
                      placeholder: _ctx.$t('label.fecha.nacimiento'),
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                    }, null, 8, ["model-value", "onUpdate:modelValue", "onBlur", "placeholder", "class"]),
                    _createElementVNode("span", _hoisted_68, [
                      _createVNode(_component_ErrorMessage, { name: "fechaNacimiento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('label.disciplina')) + " (" + _toDisplayString(_ctx.$t('label.opcional')) + ")", 1),
                _createVNode(_component_Field, {
                  name: "disciplina",
                  modelValue: _ctx.formData.disciplina,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.disciplina) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.disciplina')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_71, [
                      _createVNode(_component_ErrorMessage, { name: "disciplina" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            (_ctx.estadoAcreditadoExistente !== 'loading' && _ctx.estadoAcreditadoExistente === 'no-existe')
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('label.clave.actualizacion')), 1),
                      _createVNode(_component_Field, {
                        name: "claveActualizacion",
                        modelValue: _ctx.formData.claveActualizacion,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.claveActualizacion) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "mail",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                            placeholder: _ctx.$t('label.clave.actualizacion')
                          }), null, 16, ["placeholder", "class"]),
                          _createElementVNode("span", _hoisted_76, [
                            _createVNode(_component_ErrorMessage, { name: "claveActualizacion" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("details", _hoisted_78, [
                      _createElementVNode("summary", _hoisted_79, [
                        _createTextVNode(_toDisplayString(_ctx.$t('label.detalle.clave.titulo')) + " ", 1),
                        _cache[26] || (_cache[26] = _createElementVNode("span", { class: "relative w-4 h-4" }, [
                          _createElementVNode("i", { class: "pi pi-plus absolute inset-0 transition-opacity duration-200 group-open:opacity-0" }),
                          _createElementVNode("i", { class: "pi pi-minus absolute inset-0 opacity-0 transition-opacity duration-200 group-open:opacity-100" })
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('label.detalle.clave.linea1')), 1),
                        _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t('label.detalle.clave.linea2')), 1),
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('label.detalle.clave.linea3')), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.estadoAcreditadoExistente !== 'loading' && _ctx.estadoAcreditadoExistente === 'existe')
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createElementVNode("button", {
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cambiarClave && _ctx.cambiarClave(...args))),
                    type: "button",
                    class: "px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl",
                    disabled: _ctx.isSubmitting
                  }, [
                    _cache[27] || (_cache[27] = _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cambiar.clave')), 1)
                  ], 8, _hoisted_85)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.formData.recibirNodedades,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.recibirNodedades) = $event)),
                  inputId: "recibirNotificaciones"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t('label.acepto.recibir')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("button", {
                type: "submit",
                class: "px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_91, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_92, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.registrarme')), 1)
              ], 8, _hoisted_90),
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.salirCancelar && _ctx.salirCancelar(...args))),
                type: "button",
                class: "px-4 py-2 bg-transparent border-red-600 hover:bg-red-600 text-red-600 font-semibold hover:text-white border rounded-xl",
                disabled: _ctx.isSubmitting
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
              ], 8, _hoisted_93)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ]),
    _createVNode(_component_FooterSection),
    (_ctx.cambiarPasswordVisible)
      ? (_openBlock(), _createBlock(_component_CambiarPasswordView, {
          key: 0,
          closeFunction: _ctx.cerrarDialogoCambiarPassword,
          acreditado: _ctx.acreditado
        }, null, 8, ["closeFunction", "acreditado"]))
      : _createCommentVNode("", true),
    _createVNode(_component_BlockUI, { blocked: _ctx.isSubmitting }, null, 8, ["blocked"])
  ], 64))
}